import Form from 'scripts/poppet/form';


/**
 * ZoneForm
 * A description.
 * @version 0.1
 */
const selectors = {
};
const ZoneForm = Form.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	onRender: function(){
		if (!this.options.enabled) {
			this.disableAllInputs();
		}
	},
	
	disableAllInputs: function(){
		this.$('.disable').attr('disabled', true)
	},
});

export default ZoneForm;